import repository from '@/repositories/repository'
import url from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cliente`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${url.serialize(queryParms)}`)
        },
    }
}